// Re-scraping a delivered source (PREC-3091). Kept out of en.ts so the (over-length) main
// translation file stays within the architecture-gate line ratchet. Spread back in under
// `customEvent.rescrape` in en.ts.
export const enCustomEventRescrape = {
	resetAccess: "Reset access",
	resetAccessTitle: "Forget your credentials?",
	resetAccessConfirmation:
		"We delete the login credentials you shared for this source. You can share new ones right afterwards.",
	files: {
		title: "Scraped files",
		subtitle: "Files provided from your scraping request",
		file: "File",
		records: "Records",
		status: "Status",
		actions: "Actions",
		recordCount_one: "{{count}} record",
		recordCount_other: "{{count}} records",
		latest: "Latest",
		superseded: "Superseded",
		processing: "Processing",
		inProgress: "Scraping in progress…",
		requestedOn: "Requested {{date}}",
		download: "Download",
		empty: "No files yet — we will notify you as soon as your first file is ready.",
		delete: "Delete",
		deleteBlocked: "This file was already imported — its leads and credits stay with the list.",
		deleteTitle: "Delete this file?",
		deleteConfirmation:
			"This removes the file from the list. It has not been imported, so no leads are affected:",
		duplicates_one:
			"{{count}} duplicate lead detected and excluded. You won't be charged for these.",
		duplicates_other:
			"{{count}} duplicate leads detected and excluded. You won't be charged for these.",
	},
	mapping: {
		subtitleForFile: "Map the columns of",
		newBadge: "New",
		newColumnsWarning_one:
			"This file has {{count}} column the previous one did not. It is highlighted below — decide what to import it as.",
		newColumnsWarning_other:
			"This file has {{count}} columns the previous one did not. They are highlighted below — decide what to import them as.",
		suggesting: "Suggesting a mapping for this file…",
	},
	admin: {
		openRequest: "Open request",
		nonePending: "—",
		initialPending: "First scrape pending",
		rescrapePending: "Re-scrape pending",
		deliver: {
			action: "Deliver file",
			title: "Deliver the scraped file",
			description:
				"Upload the XLSX you scraped for {{name}}. It is attached to the list, the open request is closed and whoever ordered it is notified.",
			submit: "Deliver",
			rejected: {
				wrongType: 'Only .xlsx files can be delivered — "{{name}}" is not one.',
				tooManyFiles: "Deliver one file at a time.",
			},
		},
		markDelivered: "Mark delivered",
		markedDelivered: "Request closed against the source's newest file.",
		deliveredAfterCancel:
			"Delivered as a new file: the customer had cancelled the open request in the meantime, and its credit was returned.",
		filesAssigned: "Files assigned to the source.",
		// One sentence per refusal the API can answer with (PREC-3974). The single generic message
		// they replaced blamed the file for every failure, including a source with no list at all.
		errors: {
			noUnclaimedFile:
				"Attach the scraped file to this source first — there is nothing to mark as delivered.",
			requestNotOpen: "This request has already been closed.",
			emptyFile: "The first sheet of this file has no rows.",
			listNotFound: "This source is not attached to a list, so the file has nowhere to go.",
			noFileProvided: "No file arrived — pick the XLSX again.",
			notFound: "This request no longer exists. Reload the page.",
			forbidden: "You are not allowed to deliver for this source.",
			generic: "The delivery failed. Please try again, or check the API logs for the reason.",
		},
	},
	button: "Request to re-scrape the list",
	pending: "A re-scrape is in progress. We'll notify you when the new file is ready.",
	cancel: "Cancel request",
	restart: {
		title: "Start processing the new file?",
		description:
			"This list has already finished, so it will not pick the file up on its own. Start it now to enrich the new leads.",
		scope:
			"Only the new file is processed — the leads already in your list stay untouched, and duplicates are skipped without charge.",
		later: "You can also start it later from the list itself.",
		confirm: "Start processing",
		started: "Processing started — the new leads will appear as they are enriched",
	},
	modal: {
		title: "Request re-scrape?",
		description:
			"We'll re-scrape the source URL and provide an updated file with the latest records. Your existing file stays available for reference.",
		cost: "Cost",
		costValue: "{{amount}} scraping credits",
		dedupNote:
			"We automatically deduplicate leads across scrapes. You won't be charged enrichment credits for leads that already appeared in a previous file.",
		confirm: "Request re-scrape",
		notEnoughCredits:
			"You do not have enough scraping credits left. Buy credits to request another scrape.",
		buyCredits: "Buy credits",
		balance: "{{amount}} available",
	},
	toast: {
		// PREC-4456: the amount comes from the cancel's answer; the initial request is no re-scrape.
		cancelled: "Request cancelled",
		cancelledInitial_one: "Scraping request cancelled — {{count}} scraping credit returned",
		cancelledInitial_other: "Scraping request cancelled — {{count}} scraping credits returned",
		cancelledRescrape_one: "Re-scrape cancelled — {{count}} scraping credit returned",
		cancelledRescrape_other: "Re-scrape cancelled — {{count}} scraping credits returned",
		cancelledNothingCharged:
			"Request cancelled — nothing was charged for this request, so there is nothing to return",
		cancelledChargeUnresolved:
			"Request cancelled — we could not match it to a charge, so no credit was returned automatically. Contact support if you were charged.",
		requested: "Re-scrape requested — we'll notify you when the file is ready",
		failed: "The re-scrape could not be requested. Please try again.",
	},
};
